import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'next-i18next';

import { ButtonV3 } from 'components/ComponentV2';
import { TextArea } from 'components/form';
import { useAIGeneratedResponse } from 'pages/candidate/applications/useAIGeneratedResponse';

import styles from './CoverLetterViewer.module.scss';

interface CoverLetterViewerProps {
  coverLetterData: string;
  isProfileComplete: boolean;
  companyName: string;
}

const CoverLetterViewer: React.FC<CoverLetterViewerProps> = (props) => {
  const { coverLetterData, isProfileComplete, companyName } = props;
  const [t] = useTranslation('candidate.cover-letter');

  const { exportCoverLetterPDF, copyCoverLetter, isLoading } =
    useAIGeneratedResponse();

  return (
    <div
      className={cn(styles.viewCoverLetterWrapper, {
        [styles.disabled]: !isProfileComplete,
      })}
    >
      <div className={styles.coverLetterView}>
        {coverLetterData ? (
          <TextArea
            className={styles.coverLetterViewData}
            value={coverLetterData}
            isValid
            disabled
          />
        ) : (
          <div className={styles.coverLetterViewEmpty}>
            <p>{t('cover-letter-viewer.cover-letter-empty-view')}</p>
          </div>
        )}
      </div>
      <div className={styles.actions}>
        <ButtonV3
          size="small"
          color="secondary"
          startIcon="icon_download"
          disabled={!coverLetterData}
          isLoading={isLoading}
          onClick={() => exportCoverLetterPDF(coverLetterData, companyName)}
        >
          {t('cover-letter-viewer.export')}
        </ButtonV3>
        <ButtonV3
          size="small"
          startIcon="icon_copy"
          disabled={!coverLetterData}
          onClick={() => copyCoverLetter(coverLetterData)}
        >
          {t('cover-letter-viewer.copy')}
        </ButtonV3>
      </div>
    </div>
  );
};

export default CoverLetterViewer;
